<template>  
  <div class="pageorder">
    <mu-appbar>
        <div class="title-text">
          <p>{{pageTitle}}</p>   
        </div>
        <mu-icon-button v-on:click="GoHistory" icon=":fa fa-angle-left" slot="left"/>
        <mu-icon-button to="/usercenter/pintuanOrderSearch" icon=":fa fa-xisearch" slot="right"/>
        <mu-icon-button v-on:click="RightButonClick()" icon=":fa fa-more" slot="right"/>
        <XR-drawer right :open="rightDrawer" :docked="docked" width="70%" @close="closeDrawer()">
          <div class="right-condition">
            <div class="condition-item">
              <div class="title">下单时间</div>
              <div class="condition-content create-time">
                <div :class="searchInfo.searchTimeType==0?'value select':'value'" @click="searchTimeSelect(0)">全部</div>
                <div :class="searchInfo.searchTimeType==1?'value select':'value'" @click="searchTimeSelect(1)">一个月内</div>
                <div :class="searchInfo.searchTimeType==2?'value select':'value'" @click="searchTimeSelect(2)">一个月至三个月</div>
                <div :class="searchInfo.searchTimeType==3?'value select':'value'" @click="searchTimeSelect(3)">三个月至六个月</div>
                <div :class="searchInfo.searchTimeType==4?'value select':'value'" @click="searchTimeSelect(4)">六个月至一年</div>
                <div :class="searchInfo.searchTimeType==5?'value select':'value'" @click="searchTimeSelect(5)">一年以上</div>
              </div>
            </div>
          </div>
          <div class="condition-button">
            <div class="cbutton condition-reset" @click="searchTimeSearch(0)">重置</div>
            <div class="cbutton condition-yes" @click="searchTimeSearch(searchInfo.searchTimeType)">确定</div>
          </div>
        </XR-drawer>
    </mu-appbar>
    <v-scroll :on-refresh="onRefresh" :on-infinite="onInfinite" ref="scroll">
      <div class="state-bar">
        <div :class="searchInfo.status==''?'state-item select':'state-item'" @click="searchTypeSearch('')">全部</div>
        <div :class="searchInfo.status==1?'state-item select':'state-item'" @click="searchTypeSearch(1)">待支付</div>
        <div :class="searchInfo.status==2?'state-item select':'state-item'" @click="searchTypeSearch(2)">待分享</div>
        <div :class="searchInfo.status==3?'state-item select':'state-item'" @click="searchTypeSearch(3)">待发货</div>
        <div :class="searchInfo.status==4?'state-item select':'state-item'" @click="searchTypeSearch(4)">待收货</div>
        <div :class="searchInfo.status==5?'state-item select':'state-item'" @click="searchTypeSearch(5)">已完成</div>
      </div>
    
      <div class="order-list" v-if="!loaded">
        <div class="order-item" v-for="orderEntity in orderList" :key="orderEntity.Fid">
          <div class="shoptip">
            <img  class="shop-logo" :src="orderEntity.ShopLogo?orderEntity.ShopLogo:siteConfig.Icon" />
            <p class="shop-name">{{orderEntity.ShopName}}</p>
            <p class="state">{{orderEntity.Fstatus}}</p>
          </div>
          <div class="hidden-scorll">
            <router-link :to="'/usercenter/pintuanorderdetail?orderNo='+orderEntity.Fid">
              <div class="suborder-item-list">
                <div :class="orderEntity.Fsuborder.length>1?'suborder-item more':'suborder-item'">
                  <template v-for="orderItem in orderEntity.Fsuborder">                    
                    <img :src="orderItem.FproductImage?orderItem.FproductImage:IMGServer_URL+'/images/index-item-default.png'" class="order-img" />
                    <p v-if="orderEntity.Fsuborder.length==1" class="product-name" :style="{width:suborderItemProductNameWidth+'px'}">
                      {{orderItem.FproductName}}
                    </p>
                  </template>
                </div>
              </div>
            </router-link>
          </div>
          <div class="order-total">
            <p class="total-text">共{{orderEntity.Fsuborder.length}}件商品 实付款：<span><i class="fa fa-rmb"></i>{{orderEntity.Fpayable.toFixed(2)}}</span></p>
          </div>
          <div class="operator" v-if="!loaded">
            <div class="button-list">
              <mu-raised-button label="取消订单" @click="orderCancel(orderEntity.ForderNumber)" class="orderBtn receive" v-if="orderEntity.Fstatus == '待付款' "></mu-raised-button>
              <router-link :to="'/groupShop/orderPay?Fid='+orderEntity.Fid+'&orderNumber='+ orderEntity.ForderNumber" v-if="orderEntity.Fstatus == '待付款' ">
                <mu-raised-button label="付款" class="button-item gobuy" primary></mu-raised-button>
              </router-link>
              <mu-raised-button label="去分享" v-if="orderEntity.Fstatus=='待分享' " @click="getOrderDetail(orderEntity.Fid)" class="button-item" primary></mu-raised-button>
              <!-- <mu-raised-button label="再次购买" primary></mu-raised-button> -->
              <mu-raised-button label="确认收货" class="button-item" @click="orderConfrim(orderEntity.ForderNumber)" primary v-if="orderEntity.Fstatus=='待收货'"></mu-raised-button>
            </div>
          </div> 
        </div>
      </div>
    </v-scroll>
    <XR-toast ref="XRtoast"></XR-toast>
    <XR-PageTip ref="XRPageTip"></XR-PageTip>
  </div>
</template>

<script>
import config from '../../util/siteconfigCache'
export default {
  name : 'XR-order-head',
  data () {
    return {
      topPopup: false,
      rightDrawer: false,
      docked:false,
      fullWidth:document.documentElement.clientWidth,
      suborderItemProductNameWidth: (parseInt(document.documentElement.clientWidth)-90),
      loaded:true,
      orderList:[],
      num: 15,
      siteConfig: config.getSiteconfig(),
      pageEnd : 0, // 结束页数
      orderDetail: {},
      searchInfo:{
        searchTimeType:0,
        pageIndex : 1, // 开始页数
        status : '',
        orderNumber : this.$route.query.orderNo
      },
      scrollDone:function(){},
      pageTitle:'我的拼团'
    }
  },
  mounted(){
    this.getCacheSearch()
    this.getOrderList(true)
    this.searchInfo.searchTimeType = 0
  },
  methods: {
    RightButonClick: function(){
      this.topPopup = false
      this.rightDrawer = true
    },   
    GoHistory(){
      this.$router.goBack()
    },
    getOrderList(isNewSearch){  
      this.$refs.XRtoast.load()

      if(isNewSearch){        
        this.searchInfo.pageIndex=1  
      }
      else{        
        this.searchInfo.pageIndex++
      }
      var ths = this;   
      ths.$post(
        "/Shop/PinTuanServer/WapOrderGetList",
        JSON.stringify(this.searchInfo)
      ).then(function(res) {
        ths.scrollDone()
        ths.$refs.XRtoast.hide()
        if(!res.IsSuccess){          
          if(isNewSearch){
            ths.orderList = []    
            ths.$refs.XRPageTip.ShowEmpty(res.Msg)
          }else{            
            ths.$refs.XRtoast.failed(res.Msg, true)    
          }  
        }else{    
          if(isNewSearch){
            ths.orderList =res.Data.list     
            if(res.Data.total==0){
              ths.$refs.XRPageTip.ShowEmpty('暂无更多订单',true)
            }       
          }
          else{          
            for(var i = 0; i < res.Data.list.length;i++){            
              ths.orderList.push(res.Data.list[i])
            }
          }
          ths.pageEnd = res.Data.total%ths.num!=0? parseInt(res.Data.total/ths.num)+1:res.Data.total/ths.num
          if(ths.orderList.length<=0){            
            ths.$refs.XRPageTip.ShowEmpty('暂无订单')
          }else{            
            ths.$refs.XRPageTip.initTip()
          }

          ths.loaded =false
          ths.$refs.XRtoast.hide()
        }
      });
    },
    getOrderDetail(Fid){
      var ths = this;   
      ths.$post(
        "/Shop/PinTuanServer/WapOrderGetInfoById",
        JSON.stringify({id: Fid})
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.orderDetail = res.Data
          window.location.href = "/#/groupShop/groupShopShar?skuId=" + ths.orderDetail.Fsku+'&groupId='+ ths.orderDetail.Fgroupid
          ths.$refs.XRtoast.hide()         
        }
      });
    },
    addCacheSearch(){      
      window.localStorage.RetailOrderSearchCache = JSON.stringify(this.searchInfo)
    },
    getCacheSearch(){
      var cacheJson = window.localStorage.RetailOrderSearchCache
      if(cacheJson){
        this.searchInfo = JSON.parse(cacheJson)
        this.searchInfo.orderNumber = this.$route.query.orderNo
      }
    },
    searchOrderType(type, searchType){
      this.close('top')
      this.loaded =true

      if(searchType == 'twoOrderType'){
        this.searchInfo.twoOrderType = type
        this.searchInfo.deliveryType = 0
      }else{
        this.searchInfo.twoOrderType = 0
        this.searchInfo.deliveryType = type
      }

      if(type ==3){
        this.pageTitle='秒杀订单'
      }
      else if(type ==1){
        this.pageTitle='物流订单'
      }
      else if(type ==2){
        this.pageTitle='自提订单'
      }
      else{
        this.pageTitle = '我的订单'
      }

      this.addCacheSearch()

      this.getOrderList(true)
    },
    searchTypeSearch(type){
      this.loaded =true
      this.searchInfo.status = type

      this.addCacheSearch()
      this.getOrderList(true)
    },
    searchTimeSelect(timeType){
      this.searchInfo.searchTimeType = timeType

      this.addCacheSearch()
    },
    closeDrawer(){
      this.rightDrawer = false
    },
    searchTimeSearch(timeType){
      this.loaded =true
      this.searchInfo.searchTimeType = timeType
      
      this.addCacheSearch()

      this.closeDrawer()
      this.getOrderList(true)
    },    
    orderConfrim(orderNumber){      
      var ths = this;   
      ths.$post(
        "/Shop/PinTuanServer/WapReceivingGoods",
        JSON.stringify({orderNumber: orderNumber, userType:1})
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.$refs.XRtoast.success(res.Msg, true)
          ths.getOrderList(true)
        }
      });
    },
    orderCancel(orderNo){      
      var ths = this;   
      ths.$post(
        "/Shop/PintuanServer/orderCancel",
        JSON.stringify({orderNumber: orderNo})
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.$refs.XRtoast.successCallback(res.Msg, function(){
            ths.getOrderList(true)
          })
        }
      });
    },
    // orderConfrim(orderNumber){      
    //   var ths = this; 
    //   ths.$post(
    //     "/Shop/RetailServer/WapReceivingGoods",
    //     JSON.stringify({orderNumber: orderNumber, userType:1})
    //   ).then(function(res) {
    //     if(!res.IsSuccess){
    //       ths.$refs.XRtoast.failed(res.Msg, true)
    //     }else{    
    //       ths.$refs.XRtoast.successCallback(res.Msg, function(){
    //         ths.getOrderList(true)
    //       })
    //     }
    //   });
    // },
    onRefresh(done) {
      //this.getOrderList();
      done() // call done      
    },
    onInfinite(done) {
      this.scrollDone = done
      if(this.searchInfo.pageIndex+1 > this.pageEnd){
        this.$refs.XRtoast.failed("已经到最后一页", true)
        this.$refs.scroll.infiniteDone()
        return
      }
      this.getOrderList(false);     
    }
  }
}
</script>

<style>
.pageorder .xr-pageTip{
  top:104px;
}
.pageorder .child-view{
  background: #eee;
}
.pageorder .mu-appbar{
  position: relative;
  height: 46px;
  text-align: center;
  z-index: 20180101;
}
.pageorder .mu-appbar-title {
  font-size: 16px;
}
.pageorder .title .mu-icon-button {
  position: absolute;
  left: 0;
  top: 0;
  color:white;
}
.pageorder .title .title-text {
  margin: 0;
  padding:0;
  line-height: 48px;
}
.pageorder-popup {
  width: 100%;
  top:46px;
  height: 260px;
  z-index: 1;
  padding: 20px 0;
}
.pageorder-popup .popuptitle .title{
  overflow: hidden;
}
.pageorder-popup .popuptitle .title .text{
  float: left; 
  width:20%;
  text-align: center;
  line-height: 24px;
  color:#ccc;
}
.pageorder-popup .popuptitle .title .line{
  float: left; 
  height: 1px;
  background:#eee;
  width: 80%;
  border: none;
  margin-top: 10px;
}
.pageorder-popup .button-list{
  padding: 20px 0;
}
.pageorder-popup .button-list .demo-flat-button.select {
  color:red;
}


.pageorder .state-bar{
  overflow: hidden;
  background: white;
}
.pageorder .state-bar .state-item{
  float: left;
  width: 16.66%;
  line-height: 48px;
  text-align: center;
  font-size: 12px;
}
.pageorder .state-bar .state-item.select{
  color:red;
}

.pageorder .right-condition{
  overflow: hidden;
}
.pageorder .right-condition .condition-item{
  overflow: hidden;
}
.pageorder .right-condition .condition-item .title{
  text-align: left;
  font-size: 14px;
  line-height: 24px;
  padding: 20px 10px 0 20px;
}
.pageorder .right-condition .condition-item .condition-content{
  overflow: hidden;
  padding: 10px;
}
.pageorder .right-condition .condition-item  .condition-content .value{
  float: left;
  width: 45.9%;
  font-size: 12px;
  border: 1px solid #eee;
  margin: 2%;
  line-height: 24px;
  border-radius: 4px;
  background: #eee;
}
.pageorder .right-condition .condition-item  .condition-content .value.select{
  float: left;
  width: 45.9%;
  font-size: 12px;
  border: 1px solid red;
  margin: 2%;
  line-height: 24px;
  border-radius: 4px;
  background: white;
}
.pageorder .condition-button{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 46px;
  line-height: 46px;
}
.pageorder .condition-button .cbutton{
  float: left;
  width: 50%;
  border-top:1px solid #eee;
}
.pageorder .condition-button .condition-yes{
  background: red;
  border-top:1px solid #eee;
  color:white;
}


.pageorder .order-list{
  overflow: hidden;
}
.pageorder .order-item{
  background: white;
  position: relative;
  margin: 10px 0;
  padding-bottom: 50px;
}
.pageorder .shoptip{
  overflow: hidden;
  background: white;
  padding:0 10px;
}
.pageorder .shoptip .shop-logo{
  float: left;
  line-height: 48px;
  height: 24px;
  margin: 12px 12px 12px 0;
}
.pageorder .shoptip .shop-name{
  float: left;
  line-height: 48px;
}
.pageorder .shoptip .state{
  float: right;
  line-height: 48px;
  color:Red;
}

.pageorder .hidden-scorll{
  overflow: hidden;
}
.pageorder .suborder-item-list{
  background: #F8F8F8;
  overflow-x:scroll;
  overflow-y: hidden;

}
.pageorder .suborder-item{
  width:100%;
  overflow: hidden;
  padding: 15px 0;
}
.pageorder .suborder-item.more{
  width:710px;
}
.pageorder .suborder-item .order-img{
  width: 60px;
  float: left;
  border: 1px solid #eee;
  padding: 1px;
  background: white;
  margin-left: 10px;
  height: 60px;
  object-fit: cover;
}
.pageorder .suborder-item .product-name{
  float: left;
  padding: 1px;
  margin-left: 10px;
  word-break: break-all;
  overflow: hidden;
  height: 60px;
  line-height: 20px;
  color:#333;
}

.pageorder .order-total{
  overflow: hidden;
  padding:0 10px;
}
.pageorder .total-text{
  float: right;  
  font-size: 12px;
  line-height: 48px;
}
.pageorder .total-text span{
  font-size: 14px;
}

.pageorder .order-operator{
  overflow: hidden;
}
.pageorder .order-operator .button-list{
  float: right;
}
.pageorder .order-operator .button-list .orderBtn{
  margin: 10px 5px 10px 0;
}
.pageorder .operator{  
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
}
.pageorder .operator .button-list{
  float: right;
}
.pageorder .operator .button-list .button-item{
  margin: 10px;
    height: 32px;
  background-color: rgb(244, 67, 54);
}
.pageorder .mu-appbar .mu-appbar-title{padding-left: 50px;}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/pintuanOrderList.vue